import { defaultApi } from '@/api';

export interface BudgetPopupVisible {
  id: number;
  title: string;
  type: 'big' | 'small';
  roadmap_id: number;
  created_at: string;
  updated_at: string;
}

export async function getBudgetPopupsVisible({ roadmapId }: { roadmapId: number }) {
  const { data } = await defaultApi.get<{
    success: boolean;
    data: BudgetPopupVisible[];
  }>(`/budget-popup-visible/roadmap/${roadmapId}`);
  return data.data;
}

export async function createBudgetPopupVisible({
  roadmapId,
  newPopupVisible,
}: {
  roadmapId: number;
  newPopupVisible: { title: string; type: 'big' | 'small' };
}) {
  const { data } = await defaultApi.post<{
    success: boolean;
    data: BudgetPopupVisible;
  }>(`/budget-popup-visible/${roadmapId}`, newPopupVisible);
  return data.data;
}

export async function deleteBudgetPopupVisible({ fieldId }: { fieldId: number }) {
  const { data } = await defaultApi.delete<{
    success: boolean;
    message: string;
  }>(`/budget-popup-visible/${fieldId}`);
  return data;
}